module.exports = __webpack_public_path__ + "static/media/replay-arrow.ba24386f.svg";